<div class="wrapper row pad-horizontal-10">
  <div class="column twelve md-nine">
    <div class="pad-top-20 pad-horizontal-10 row column twelve lg-push-two md-ten md-push-two">
      @if (icons$ | async; as icons) {
        <div class="flex justify-center items-center">
          <div class="icon-container flex">
            @for (iconClass of icons.vehicleIconCount; track iconClass) {
              <div class="icon-auto margin-horizontal-4" [ngClass]="iconClass"></div>
            }
          </div>
          <h3 class="font-header margin-0 margin-left-12">
            {{ vehicleDescription$ | async }}
            @if (icons.vehicleRestNumber >= 3) {
              <div class="text-more">+{{ icons.vehicleRestNumber }} more</div>
            }
          </h3>
        </div>
      }

      <div class="flex justify-center row rate-compare-container margin-top-60">
        <div class="column four current-premium">
          <p class="text-center pad-4">CURRENT</p>
          <ds-premium-cost
            [totalCost]="(vehicleRate$ | async)?.priorCost"
            [monthlyPremium]="(vehicleRate$ | async)?.priorMonthly"
            [termMonths]="(vehicleRate$ | async)?.termMonths"
          >
          </ds-premium-cost>
        </div>

        <div class="updated-premium column four">
          <p class="text-center pad-4">UPDATED</p>
          <ds-premium-cost
            [totalCost]="(vehicleRate$ | async)?.totalCost"
            [monthlyPremium]="(vehicleRate$ | async)?.monthlyPremium"
            [termMonths]="(vehicleRate$ | async)?.termMonths"
          >
          </ds-premium-cost>
        </div>
      </div>

      <hr class="margin-top-60 margin-bottom-30" />

      <h1 class="pad-top-2 margin-bottom-50">
        Updated Coverages for your {{ vehicleDescription$ | async }}
      </h1>

      @if (vehicleCoveragesSummaryList$ | async; as vehicleCoveragesSummaryList) {
        <div class="margin-bottom-40">
          <div class="section-header pad-bottom-8 margin-bottom-20 font-size-1 flex items-center">
            <span class="icon-binoculars margin-right-20 bold-header font-size-2"></span>
            <span
              dsContent
              [contentPath]="'policy.changeCoverage.summary.updateCoverageDeductibleHeader'"
              class="bold-header font-size-1-50 font-weight-semibold"
              data-cy="addVehicleDeductibleHeader"
            ></span>
          </div>
          <amfam-quote-summary [summaryList]="vehicleCoveragesSummaryList"></amfam-quote-summary>
        </div>
      }

      @if (policyCoveragesSummaryList$ | async; as policyCoveragesSummaryList) {
        <div class="margin-bottom-40">
          <div class="section-header pad-bottom-16 font-size-1 flex items-center">
            <span class="icon-claims margin-right-20 bold-header font-size-2"></span>
            <span
              dsContent
              [contentPath]="'policy.changeCoverage.summary.updateCoverageIncludedCoverageHeader'"
              class="bold-header font-size-1-50 font-weight-semibold"
            ></span>
          </div>
          <amfam-quote-summary [summaryList]="policyCoveragesSummaryList"></amfam-quote-summary>
        </div>
      }
      @if (discountsOnCoveragesSummaryList$ | async; as discountsOnCoveragesSummaryList) {
        <div class="margin-bottom-40">
          <div class="section-header pad-bottom-16 font-size-1 flex items-center">
            <span class="icon-discounts margin-right-20 bold-header font-size-2"></span>
            <span
              dsContent
              [contentPath]="'policy.changeCoverage.summary.updateCoverageDiscountsHeader'"
              class="bold-header font-size-1-50 font-weight-semibold"
            ></span>
          </div>
          <amfam-quote-summary
            [summaryList]="discountsOnCoveragesSummaryList"
          ></amfam-quote-summary>
        </div>
      }
    </div>
    <div
      class="row column twelve lg-push-two md-ten md-push-two margin-bottom-40 pad-horizontal-10"
    >
      <blockquote class="border -primary-800 margin-0 pad-vertical-16 pad-horizontal-20">
        @if (hasAntiTheftDiscount$ | async) {
          <div
            dsContent
            [contentPath]="'policy.changeCoverage.summary.antiTheftDisclaimer'"
            class="margin-bottom-10"
          ></div>
        }
        <div
          dsContent
          [contentPath]="'policy.changeCoverage.summary.updateCoverageDiclaimer'"
        ></div>
      </blockquote>
    </div>
    <div class="pad-horizontal-10 row column twelve lg-push-two md-ten md-push-two">
      <call-to-action
        [displayBackButton]="true"
        [tertiaryButtonName]="'Cancel'"
        [primaryButtonName]="'Confirm Updates'"
        (primaryEvent)="onlineBind()"
        [secondaryButtonName]="(isPartner$ | async) ? 'Send to an advisor' : 'send to my agent'"
        (secondaryEvent)="notifyAgent()"
        (tertiaryEvent)="goToOverview()"
        (backEvent)="goBackOneStep()"
        [capitalize]="(isPartner$ | async) === false"
        [actionPanel]="true"
      >
      </call-to-action>
    </div>
  </div>
</div>
